import {
	DELETE_WORK_CENTER,
	DELETE_WORK_CENTER_ERROR,
	DELETE_WORK_CENTER_SUCCESS,
} from '../../../constants';

export const deleteWorkCenterReducer = (state, actions) => {
	switch (actions.type) {
		case DELETE_WORK_CENTER:
			return {
				...state,
				loading: true,
				error: null,
				errorShow: false,
			};
		case DELETE_WORK_CENTER_ERROR:
			return {
				...state,
				loading: false,
				error: actions.payload,
				errorShow: true,
			};
		case DELETE_WORK_CENTER_SUCCESS:
			return {
				...state,
				loading: false,
				error: null,
				errorShow: false,
				workCenters: actions.payload,
			};
		default:
			return state;
	}
};
